import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Alert,
  Box,
  CircularProgress,
  Pagination,
} from "@mui/material";
import { TypographyNormal } from "../../../../components/customComponent";
import { getEquipment } from "../../../store/actions/bplrt/equipmentAction";
import { usePagination } from "../../../../components/hooks";
import EquipmentItem from "./EquipmentItem";
import { useTranslation } from "react-i18next";

const EquipmentList = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEquipment());
  }, [dispatch]);

  const { equipment, loadingAnnouncement: loadingEquipment } = useSelector(
    (state) => state.bplrtEquip
  );

  const { t } = useTranslation("bplrtEquipment");

  const [page, setPage] = useState(1);

  const [equipList, setEquipList] = useState([]);

  const DATA_PER_PAGE = 5;

  const count = Math.ceil(equipList.length / DATA_PER_PAGE);

  const _DATA = usePagination(equipList, DATA_PER_PAGE);

  const handleChangePagination = (e, page) => {
    setPage(page);
    _DATA.jump(page);
  };

  useEffect(() => {
    setEquipList(equipment?.filter((equip) => equip.isDisrupted === true));
  }, [equipment]);

  useEffect(() => {
    handleChangePagination("", 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipList]);

  if (loadingEquipment)
    return (
      <Box
        sx={{ height: "20vh" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <CircularProgress size={20} thickness={3} sx={{ color: "#1D4ED8" }} />
        <TypographyNormal sx={{ color: "#1D4ED8", mt: 2, fontWeight: 300 }}>
          {t("loadingData")}
        </TypographyNormal>
      </Box>
    );

  return (
    <>
      {!equipList.length || equipList === undefined ? (
        <Alert severity="info" variant="filled">
          <strong>{t("noBreakdownText")}</strong>
        </Alert>
      ) : (
        <TableContainer
          component={Paper}
          sx={{ overflowY: "auto", maxHeight: 500, boxShadow: 3 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t("tableHeader.station")}</TableCell>
                <TableCell>{t("tableHeader.equipment")}</TableCell>
                {/* TODO */}
                {/* <TableCell>Updated At</TableCell> */}
                <TableCell align="right">{t("tableHeader.action")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {equipList &&
                _DATA
                  .currentData()
                  .map((equip) => (
                    <EquipmentItem key={equip.id} equipment={equip} />
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!loadingEquipment && equipment.length ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            pt: 4,
            pb: 2,
            pr: 2,
          }}
        >
          <Pagination
            count={count}
            page={page}
            shape="rounded"
            color="primary"
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </>
  );
};

export default EquipmentList;
